import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ListIcon from '@material-ui/icons/List';
import { useDispatch, useSelector } from "react-redux";
import logo from '../../../assets/Logo_Blanco.png'
import { Avatar, Badge, Menu, MenuItem } from "@material-ui/core";
import { startLogout } from "../../../actions/auth";
import { useHistory } from "react-router";
import NavBarIzquierda from "./navBarIzquierda";
import NotificationsIcon from '@material-ui/icons/Notifications'
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    },
    toolbar: {
        height: 64
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        fontStyle: "italic",
        fontWeight: "bold",
        color:"#fff"
    },
    logo: {
        width: "100%",
        height: 'auto',
        maxWidth: 145
    },
    avatar: {
        marginRight: 5,
        marginLeft: 5
    },
    seccionDesktop: {
        display: "none",
        [theme.breakpoints.up("md")]: {
          display: "flex",
          justifyContent: "center",
          alignItems:"center",
          marginLeft: "auto"
        },
      },
}));
const AppBarAfiliado = () => {
    const auth = useSelector((state) => state.auth);
    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [drawer, setDrawer] = React.useState(false);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const salirSesionApp = () => {
        handleClose()
        dispatch(startLogout(history, true));
    };
    return (
        <div className={classes.root}>

            <AppBar position="fixed">
                <NavBarIzquierda drawer={drawer} setDrawer={setDrawer} />
                <Toolbar className={classes.toolbar}>
                    {
                        auth.userName &&
                        <IconButton edge="start" onClick={() => setDrawer(true)} className={classes.menuButton} color="inherit" aria-label="menu">
                            <ListIcon />
                        </IconButton>
                    }
                    {
                        auth.userName
                            ?
                            <Link style={{textDecoration:"none"}} to="/afiliado/inicio"><Typography variant="h6" className={classes.title}>Mi OSPEDYC</Typography></Link> 
                            :
                            <a href="https://www.ospedyc.org/"><img src={logo} className={classes.logo} alt="Logo afiliado"></img></a>
                    }
                    {
                        auth.userName &&
                        <div className={classes.seccionDesktop}>
                            <MenuItem>
                                <IconButton aria-label="show 11 new notifications" color="inherit">
                                    <Badge badgeContent={0} color="secondary">
                                        <NotificationsIcon />
                                    </Badge>
                                </IconButton>
                            </MenuItem>
                            <Typography>{auth.userName}</Typography>
                            <div>
                                <Avatar className={classes.avatar} onClick={handleClick} style={{ cursor: "pointer" }} />
                                <Menu
                                    id="simple-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                    getContentAnchorEl={null}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                    transformOrigin={{ vertical: "top", horizontal: "right" }}

                                >
                                    <MenuItem component={Link} to="/afiliado/mi-perfil">Mi Perfil</MenuItem>
                                    <MenuItem onClick={salirSesionApp}>Salir</MenuItem>
                                </Menu>
                            </div>
                        </div>
                    }
                </Toolbar>
            </AppBar>
            <Toolbar />
        </div>
    )
};

export default AppBarAfiliado;
